<template>
  <div class="enroll-success">
    <div class="success-form">
      <div class="title">
        <div>{{ year }}河北传媒学院高考录取结果</div>
        <div class="back" @click="$emit('navBack')">&lt; 返回</div>
      </div>
      <div class="form-body">
        <img
          src="../../../assets/enroll/img_lq.png"
          alt=""
          class="img-success"
        />
        <div class="success-text">恭喜你被我校录取!</div>
        <div class="success-tip">
          如果通知书邮寄信息不正确，请尽快联系我校招生办进行修改。0311-85334781
        </div>

        <div class="info-wrapper">
          <div class="top">
            <img
              src="../../../assets/enroll/icon_grxx.png"
              alt=""
              class="info-img"
            />
            <div class="info-title">个人信息</div>
          </div>
          <div class="info-content">
            <div>姓名：{{ info.examineeName }}（{{ info.sex }}）</div>
            <div>考生号：{{ info.examNumber }}</div>
            <div>身份证号：{{ info.credenNumber }}</div>
          </div>
        </div>

        <div class="info-wrapper">
          <div class="top">
            <img
              src="../../../assets/enroll/icon_lqzy.png"
              alt=""
              class="info-img"
            />
            <div class="info-title">录取专业</div>
          </div>
          <div class="info-content">
            <div>录取层次：{{ info.admittedLevel }}</div>
            <div>录取专业：{{ formatSpecialty(info.admittedSpecialty) }}</div>
            <div>通知书编号：{{ info.offerNo }}</div>
          </div>
        </div>

        <div class="info-wrapper">
          <div class="top">
            <img
              src="../../../assets/enroll/icon_yjxx.png"
              alt=""
              class="info-img"
            />
            <div class="info-title">邮寄信息</div>
          </div>
          <div class="info-content">
            <div>邮寄地址：{{ info.postAdress }}</div>
            <div>邮政编码：{{ info.postNumber }}</div>
            <div>收件人：{{ info.addressee }}</div>
            <div>联系电话：{{ info.contactNumber }}</div>
          </div>
        </div>

        <div class="info-wrapper">
          <div class="top">
            <img
              src="../../../assets/enroll/icon_yjdh.png"
              alt=""
              class="info-img"
            />
            <div class="info-title">邮寄单号</div>
          </div>
          <div class="info-content">
            <div>EMS单号：{{ info.trackingNumber }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnrollSuccess",
  props: {
    info: Object,
  },
  data() {
    return {
      year: null,
    };
  },
  created() {
    this.year = new Date().getFullYear();
  },
  methods: {
    formatSpecialty(str) {
      let a = str
        .replace("音乐表演（器乐）", "音乐表演")
        .replace("音乐表演（声乐）", "音乐表演")
        .replace("休闲体育（高水平）", "休闲体育")
        .replace("流行音乐（声乐）", "流行音乐")
        .replace("流行音乐（器乐）", "流行音乐");
      return a;
    },
  },
};
</script>

<style lang="scss" scoped>
.enroll-success {
  background: #fff;
  padding-bottom: 70px;

  .success-form {
    position: relative;
    background: #ffffff;
    border: 1px solid #700005;
    border-radius: 8px;
    width: 1160px;
    box-sizing: border-box;
    max-width: 100%;
    overflow: hidden;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: -64px;
    margin-bottom: -64px;

    .title {
      position: relative;
      font-size: 22px;
      color: #fff;
      height: 64px;
      text-align: center;
      line-height: 64px;
      background: #700005;
      opacity: 1;
      .back {
        position: absolute;
        top: 0;
        left: 24px;
        font-size: 18px;
        font-weight: 100;
        cursor: pointer;
      }
    }
    .form-body {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 32px 48px;

      .img-success {
        width: 126px;
      }

      .success-text {
        color: #700005;
        font-size: 24px;
        margin-top: 16px;
        margin-bottom: 8px;
      }
      .success-tip {
        color: #700005;
        font-size: 14px;
        margin-bottom: 20px;
        text-align: center;
      }
    }
  }

  .info-wrapper {
    width: 100%;
    margin-top: 25px;
    .top {
      color: #700005;
      display: flex;
      align-items: center;
      padding-bottom: 6px;
      border-bottom: 2px solid rgba(112, 0, 5, 0.2);
      .info-img {
        width: 18px;
        margin-right: 10px;
      }
    }
    .info-content {
      color: #535353;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 20px;
      > div {
        padding: 10px 0;
      }
      > div:not(:last-child) {
        margin-right: 80px;
      }
    }
  }
}

@media only screen and (max-width: 600px) {
  .enroll-success {
    padding-bottom: 0;

    .success-form {
      top: -40px;
      margin-bottom: -40px;
      width: 93%;

      .title {
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        .back {
          left: 5px;
          font-size: 12px;
          font-weight: 300;
        }
      }
      .form-body {
        padding: 20px 15px 0;
        .img-success {
          width: 86px;
        }
        .success-text {
          font-size: 20px;
          margin-top: 16px;
          margin-bottom: 8px;
        }
        .success-tip {
          font-size: 12px;
          margin-bottom: 10px;
        }
      }
    }

    .info-wrapper {
      width: 100%;
      margin-top: 5px;
      .top {
        padding-bottom: 6px;
        .info-img {
          width: 18px;
          margin-right: 10px;
        }
      }
      .info-content {
        font-size: 14px;
        color: #535353;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        padding: 6px;
        > div {
          padding: 8px 0;
        }
        > div:not(:last-child) {
          margin-right: 30px;
        }
      }
    }
  }
}
</style>
